import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="relative py-8 sm:py-16 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-120">
      <div className="absolute inset-0 bg-gradient-to-br from-agua to-deep z-0" data-id="element-121"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-122">
        <div className="inline-flex items-center justify-center w-14 h-14 sm:w-20 sm:h-20 rounded-full bg-white/10 mb-4 sm:mb-6 backdrop-blur-sm border border-white/20" data-id="element-123">
          <ShieldCheck className="w-7 h-7 sm:w-10 sm:h-10 text-white" data-id="element-124" />
        </div>

        <h2 className="text-2xl sm:text-4xl font-black text-white mb-4 sm:mb-6 tracking-tight" data-id="element-125">
          ✨ GARANTÍA PROFE DE NATACIÓN RESUELTO — 7 DÍAS ✨
        </h2>

        <p className="text-lg sm:text-xl text-white/90 font-medium mb-5 sm:mb-8 leading-relaxed" data-id="element-126">
          Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
          querés. Si en 7 días no es lo que esperabas: Te devolvemos el 100%.
          Sin preguntas. Sin formularios. Sin drama.
        </p>

        <p className="text-white/80 text-base mb-5 sm:mb-8" data-id="element-127">
          La confianza que tenemos en Profe de Natación Resuelto™ nos permite
          hacer esa promesa sin dudar. Más de 500 profes ya lo saben.
        </p>

        <div className="inline-block bg-green-500 text-white font-black px-6 py-3 rounded-full shadow-lg border border-green-400 text-[14px]" data-id="element-128">
          TASA DE DEVOLUCIONES MENOR AL 1%
        </div>
      </div>
    </section>;
}